

































import { mixins } from 'vue-class-component'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import SearchAccount from '@/mixins/search-queries/search-account'
import { IAccountInfoInput } from '@/modules/Account/interfaces/account-form'
import { salutationValues } from '@/modules/Contact/helpers/contact'

@Component({
  components: {
    AppTextSearch,
    AppTextField,
    AppSelector,
    AppDatePicker,
    AppTextarea
  }
})
export default class AccountFormInfo extends mixins(SearchAccount) {
  @Prop({ type: Object as () => IAccountInfoInput }) value!: IAccountInfoInput

  salutations = salutationValues

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
